function getYear() {
    if (document.querySelector('#year')) {
        var d = new Date();
        var n = d.getFullYear();
        document.getElementById("year").innerHTML = n;
    }
}

window.onload = getYear();